import { makeStyles } from '@material-ui/core';
import { Modal } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import EditDescription from './EditDescription';
import theme from './theme';

const {
  colors: { background, subTextColor },
} = theme;

// Fonction utilitaire pour extraire le texte brut des éléments React
const extractText = (node) => {
  if (typeof node === 'string') {
    return node;
  }
  if (Array.isArray(node)) {
    return node.map(extractText).join('');
  }
  if (node && node.props && node.props.children) {
    return extractText(node.props.children);
  }
  return '';
};

const Description = ({ presentation, refetch }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [editDescription, setEditDescription] = useState(false);
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    if (typeof presentation === 'string') {
      const parsedPresentation = parse(presentation);
      const text = extractText(parsedPresentation);
      setCharCount(text.length);
    } else {
      setCharCount(0);
    }
  }, [presentation]);

  const handleOpenEditDescription = () => {
    setEditDescription(true);
  };
  const handleCloseEditDescription = () => {
    setEditDescription(false);
  };

  return (
    <div className={classes.container}>
      <div className={global.title}>
        <div>
          <FormattedMessage id="student.profil.description.title" />
        </div>
      </div>
      <div style={{marginTop: '8px'}} className={global.subTitle}>
        <FormattedMessage id="student.profil.personnalinfos.subTitle" />
      </div>
      <div className={classes.textarea}>
        {presentation ? (
          <div
            className={cx(css({
              position: 'relative',
              width: '100%',
              height: '140px',
              background: '#F3F7FF',
              border: '1px solid #C0D9FF',
              padding: spacing(0, 2),
              borderRadius: 6,
              resize: 'none',
              overflowY: 'auto',
              overflowWrap: 'break-word',
            }), global.infoText)}
            style={{ cursor: 'pointer' }}
            onClick={handleOpenEditDescription}
          >
            {typeof presentation === 'string'
              ? parse(presentation)
              : 'Présentation invalide'}
            <p style={{ position: 'absolute', bottom: 0, right: 16 }}>
              Caractères : {charCount}/200
            </p>
          </div>
        ) : (
          <div
            className={css({
              width: '100%',
              height: '100%',
              background: '#fbd3d5',
              border: '1px solid #F50057',
              fontFamily: 'Roboto',
              color: '#F50057',
              padding: spacing(2, 2),
              '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
              borderRadius: 6,
              resize: 'none',
              overflowY: 'auto',
            })}
            style={{ cursor: 'pointer' }}
            onClick={handleOpenEditDescription}
          >
            Cliquez dans le champ pour vous présenter.
          </div>
        )}
      </div>
      <Modal
        onCancel={handleCloseEditDescription}
        open={editDescription}
        title="Modifiez votre présentation"
      >
        <EditDescription
          close={handleCloseEditDescription}
          presentation={presentation}
          refetch={refetch}
        />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    maxWidth: '100%',
    padding: '20px 20px 0px 20px',
    display: 'flex',
    flexDirection: 'column',
  },
  textarea: {
    maxWidth: '100%',
    marginTop: 20,
    resize: 'none',
    fontFamily: 'Roboto',
    height: '100%',
    color: '#152652',
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
  },
  modifyLink: {
    a: {
      textDecoration: 'none',
      color: '#0183FF',
    },
    padding: spacing(0),
    wordWrap: 'break-word',
    maxWidth: '100%',
  },
});

Description.propTypes = {
  presentation: PropTypes.string,
  refetch: PropTypes.func,
};

export default Description;
